module.exports = __webpack_public_path__ + "static/medal-fa6824a7c8cac2d2fc30cd6252e6fa86.svg";